import { useState } from 'react';

export function useToasts() {
  const [toasts, setToasts] = useState([]);

  function push(type, message) {
    const id = Date.now() + Math.random();
    setToasts((t) => [...t, { id, type, message }]);
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 3000);
  }

  return { toasts, push };
}
